(() => {
  const btn = document.getElementById('mox-shadow-toggle');
  const badge = document.getElementById('mox-shadow-badge');

  const setBadge = (n) => {
    if (!badge) return;
    const v = Number(n || 0);
    badge.textContent = String(v);
    badge.hidden = !(v > 0);
  };

  if (btn) {
    btn.addEventListener('click', (e) => {
      e.preventDefault();          // no navegues a /cart
      document.dispatchEvent(new CustomEvent('mox:shadow:open')); // abre drawer
    });
  }

  const bootCount = () => {
    try {
      // Intenta leer del estado global consolidado (mox-draft-state.js)
      const draft = window.MOX_DRAFT?.current;

      // Si no hay draft, 0
      if (!draft) {
        setBadge(0);
        return;
      }

      // Estructura esperada: draft.lineItems.nodes (GraphQL)
      const nodes = draft.lineItems?.nodes || [];
      const qty = nodes.reduce((acc, item) => acc + (Number(item.quantity) || 0), 0);
      setBadge(qty);

    } catch (_e) {
      // Fallback silencioso
      setBadge(0);
    }
  };

  // arranque
  bootCount();

  // cuando cambie/refresque la draft
  document.addEventListener('mox:draft:changed', bootCount);
  document.addEventListener('mox:draft:refreshed', bootCount);
  document.addEventListener('mox:draft:loaded', bootCount); // Nuevo evento de mox-draft-state.js

  // Restauración desde bfcache (botón Atrás)
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      // Si viene de caché, forzamos refresco del estado (force=true)
      // para ignorar cualquier flag 'refreshing' que se haya quedado pegado.
      setTimeout(function() {
        console.log("execute bootDraftRefresh");
        window.bootDraftRefresh?.(true);  
      }, 500);
      
    }
  });

  // si tu bundle global usa esto para el badge, lo enganchamos
  if (typeof window.moxSetCartCount === 'function') {
    const prev = window.moxSetCartCount;
    window.moxSetCartCount = (n) => { setBadge(n); try { prev(n); } catch (_e) { } };
  }
})();
